import { Injectable } from '@angular/core';
import { Navigator, SingleKeyNavigationHelper, KeyBase } from '@kpd/framework-ngx';

@Injectable()
export class UsersNavigatorHelper extends SingleKeyNavigationHelper {
  constructor(navigator: Navigator) {
    super('users', navigator);
  }

  navigateToDetail(
    entityKey: KeyBase,
    editMode: boolean,
    overrideCurrentBrowserHistoryItem: boolean = false,
    replaceLastChildInBreadCrumb: boolean = false,
    params?: object,
  ): Promise<boolean> {
    return super.navigateToDetail(
      entityKey,
      editMode,
      overrideCurrentBrowserHistoryItem,
      replaceLastChildInBreadCrumb,
      params,
    );
  }
}
